import { routes } from '@/navigation/routes.tsx';
import i18n from '@/i18n'; // или откуда ты получаешь текущий язык

export const handleUserVerificationFailed = () => {
  const lang = i18n.language;
  const url = `${routes.verificationFailed}?lang=${lang}`;
  window.location.replace(url);
};
